import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import voucherQueryKeys from './voucherQueryKeys'
import { deleteVoucher } from '../service/voucherService'
import { Voucher } from '../../../pages/reporting/vouchers/types'
import { queryClient } from '../../../services/api/queryClient'

export const useCtxDeleteVoucher = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { notification, message } = App.useApp()
  const { t } = useTranslation()

  if (!companyId) {
    throw new Error('Company ID is required for vouchers.')
  }

  return useMutation({
    mutationKey: voucherQueryKeys.list({ companyId }),
    mutationFn: (voucherId: Voucher['id']) => deleteVoucher(companyId, voucherId),
    onSuccess() {
      message.success(t('messages:deleteSuccess', 'Success'))
      return queryClient.invalidateQueries({
        queryKey: voucherQueryKeys.lists()
      })
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
